import React from 'react';
import SEO from '@/components/SEO';
import BookingModule from '@/components/sections/BookingModule';
import EstimationForm from '@/components/sections/EstimationForm';
import FAQ from '@/components/ui/FAQ';
import MobileHighlight from '@/components/sections/highlights/MobileHighlight';
import HeroSection from '@/components/sections/mobile/HeroSection';
import BenefitsSection from '@/components/sections/mobile/BenefitsSection';
import ProcessSection from '@/components/sections/mobile/ProcessSection';
import CTASection from '@/components/sections/mobile/CTASection';
import TechnologiesSection from '@/components/sections/mobile/TechnologiesSection';

const MobileAppDevelopment = () => {
  const faqItems = [
    {
      question: "Sur quelles plateformes développez-vous les applications mobiles ?",
      answer: "Nous développons des applications pour iOS (iPhone, iPad) et Android, soit en natif avec Swift et Kotlin, soit en cross-platform avec Flutter. Le choix de la technologie dépend de vos besoins spécifiques, du budget et des fonctionnalités requises."
    },
    {
      question: "Combien de temps faut-il pour développer une application mobile ?",
      answer: "Le délai varie selon la complexité : 2-3 mois pour un MVP, 4-6 mois pour une application complète. Nous privilégions une approche itérative avec des livraisons régulières pour vous permettre de tester et valider les fonctionnalités au fur et à mesure."
    },
    {
      question: "Comment gérez-vous la publication sur les stores ?",
      answer: "Nous prenons en charge l'ensemble du processus de publication : préparation des assets, configuration des comptes développeur, soumission aux stores (App Store et Google Play), et suivi des validations. Nous assurons également la conformité avec les guidelines de chaque plateforme."
    },
    {
      question: "Proposez-vous des fonctionnalités hors-ligne ?",
      answer: "Oui, nous développons des applications capables de fonctionner hors-ligne avec synchronisation automatique une fois la connexion rétablie. Nous utilisons des techniques de mise en cache et de stockage local pour garantir une expérience utilisateur fluide même sans connexion."
    },
    {
      question: "Comment assurez-vous la sécurité des données ?",
      answer: "Nous implémentons les meilleures pratiques de sécurité : chiffrement des données sensibles, authentification sécurisée, protection contre les injections SQL, certificats SSL/TLS, et conformité RGPD. Nous effectuons également des audits de sécurité réguliers."
    },
    {
      question: "Que comprend la maintenance post-lancement ?",
      answer: "Notre service de maintenance inclut : les mises à jour de sécurité, la compatibilité avec les nouvelles versions d'iOS et Android, l'optimisation des performances, la correction des bugs, et l'ajout de nouvelles fonctionnalités. Nous proposons également un monitoring des crashs et des analyses d'utilisation."
    }
  ];

  return (
    <>
      <SEO
        title="Développement d'Applications Mobiles | iOS & Android"
        description="Créez des applications mobiles performantes et innovantes avec Orcsys. Expertise en développement iOS et Android, UI/UX design et solutions cross-platform. De l'idée au lancement sur l'App Store et Google Play."
        keywords="développement mobile, applications iOS, applications Android, React Native, Flutter, développement cross-platform, UI/UX mobile, app store optimization, swift, kotlin"
        type="service"
        url="https://innov.orcsys.fr/developpement-mobile"
        image="https://innov.orcsys.fr/images/mobile-development-preview.jpg"
      />
      <div className="min-h-screen bg-white">
        <HeroSection />
        <BenefitsSection />
        <ProcessSection />
        <TechnologiesSection />
        <MobileHighlight
          title="QuickPic - L'application mobile pour photos d'identité officielles"
          description="QuickPic est une application innovante permettant aux utilisateurs de capturer des photos d'identité conformes aux normes officielles directement depuis leur smartphone. Grâce à l'intelligence artificielle, l'application assure la conformité des photos pour divers documents tels que le passeport, le permis de conduire, la carte d'identité et la carte Vitale."
          imageUrl="images/quickpic-image1.png"
          secondImageUrl="images/quickpic-image2.png"
          storeRatings={{
            playStore: {
              rating: 4.8,
              reviews: 69,
              url: "https://play.google.com/store/apps/details?id=com.quickpic.app"
            },
            appStore: {
              rating: 4.7,
              reviews: 134,
              url: "https://apps.apple.com/fr/app/quickpic-photo-didentit%C3%A9/id6473794068"
            }
          }}
          stats={{
            users: 5000,
            downloads: 20000,
            achievement: "4e pour les photos d'identité en 2024"
          }}
          interestingFact="QuickPic permet aux utilisateurs de réaliser des photos d'identité officielles sans se déplacer, contribuant ainsi à une réduction significative de l'empreinte carbone liée aux déplacements pour ce type de service."

        />
        <CTASection />
        <EstimationForm />
        <BookingModule projectType="mobile" />
        <FAQ
          title="Questions Fréquentes sur le Développement Mobile"
          subtitle="Découvrez notre approche du développement d'applications mobiles"
          items={faqItems}
          className="bg-slate-50"
        />
      </div>
    </>
  );
};

export default MobileAppDevelopment;
